import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { sectors } from '../pages/sectors/sectorsData';

export default function MobileMenu({ onLinkClick }) {
  const { isEN, t } = useLanguage();
  return (
    <div className="mobile-menu">
      <Link to="/" onClick={onLinkClick}>{isEN ? 'Home' : 'الرئيسية'}</Link>
      <Link to="/about" onClick={onLinkClick}>{isEN ? 'About' : 'من نحن'}</Link>
      <div className="m-group">
        <div className="m-group__label">{isEN ? 'Our Sectors' : 'قطاعاتنا'}</div>
        <div className="m-sub">
          {sectors.map((s) => (
            <Link key={s.slug} to={s.route} onClick={onLinkClick}>{t(s.navLabel)}</Link>
          ))}
        </div>
      </div>
      <Link to="/" state={{ scrollTo: 'global' }} onClick={onLinkClick}>{isEN ? 'Global' : 'الفروع الخارجية'}</Link>
      <Link to="/media" onClick={onLinkClick}>{isEN ? 'Media Center' : 'المركز الإعلامي'}</Link>
      <Link to="/contact" onClick={onLinkClick}>{isEN ? 'Contact Us' : 'تواصل معنا'}</Link>
    </div>
  );
}
